import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../datatable/DataTable";
import "../author/author.css";
import ApiRequest from "../../helper/ApiRequest";

const tableHeader = ["Date", "Email"];
const tbody = ["createdAt", "email"];

export default function NewsLetter() {

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", "api/newsletters");
        // const result = response.authors;
        setData(response.newsletters);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  return (
    <>
      <div className="header-add-category">
        <h5>Newsletters</h5>
      </div>
      <div className="add-author-section">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
      </div>
    </>
  );
}
